import React from 'react';
import cn from 'classnames';
import styles from './FloorTooltip.module.scss';

const FloorTooltip = ({ data }) => {
  return (
    <div
      className={cn(styles.tooltip, {
        [styles.leftTooltip]: data.left > 75,
        [styles.rightTooltip]: data.left <= 75,
      })}
      style={{
        height: data.height,
        top: data.top,
      }}
    >
      {data.content}
    </div>
  );
};

export default FloorTooltip;
